import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Icon } from '@iconify/react';

const TABS = [
    {name:'Teams',icon:<Icon icon="lucide:users" width={20} />,
        link:'/'
    },
    // {name:'Tasks',icon:<Icon icon="lucide:clipboard-list" width={20} />,
    //   link:'/tasks'
    // },
    {name:'Activities',icon:<Icon icon="lucide:bar-chart-3" width={20} />,
         link:'/analytics'
    },
        {name:'To-Do',icon:<Icon icon="lucide:clipboard-check" width={20} />,
         link:'/todo'
    },
    {name:'Settings',icon:<Icon icon="lucide:settings" width={20} />,
         link:'/settings'
    },
]

const Tabs:React.FC = () => {
  let location = useLocation()

  return (
    <div className='h-20 w-full flex flex-col justify-center  border-t border-gray-200 bg-white'>
       <div className='flex justify-between h-full px-5'>
       {TABS.map((tab)=>(
         <Link to={tab.link} key={tab.name}>
            <div className={`flex flex-col gap-1 mt-2 items-center w-16 rounded-xl py-2 ${location.pathname===tab.link && 'bg-green-700'} ${location.pathname===tab.link && 'text-white'}`}>
            {tab.icon && tab.icon}
            <button  className={`text-xs`}>{tab.name}</button>
            </div>
        </Link>
       ))}
       </div>
    </div>
  )
}

export default Tabs
